import { SignOutLogo } from "../components/Icons/CheckOutLogo";
import PopUp from "../components/PopUp/PopUp"
import { FC } from "react";


interface SessionExpirationPopup {
    session: boolean;
    message: string;
    title: string;
    buttonTxt: string;
    handleLogout: () => void

}

const SessionExpirationPopup: FC<SessionExpirationPopup> = ({ session, message, title, buttonTxt, handleLogout }) => {

    const renderBody = () => {
        return <div>
            <p style={{ fontSize: "16px" }}>
                {message}

            </p>
        </div>
    };
    return (
        <>
            {session && <div className="signoutPopup">
                <PopUp
                    isOpen={true}
                    onClose={() => console.log("SessionExpired")}
                    header={title}
                    body={() => renderBody()}
                    closeButton={false}
                    onAction={() => { /* window.location.assign('/login');  */handleLogout() }}
                    ButtonApproveText={<> <SignOutLogo />  {buttonTxt}</>}
                    actionButtons={true}
                />
            </div>}
        </>
    )
}

export default SessionExpirationPopup;